import { Routes, Route } from 'react-router-dom';
import PrivateRoute from '../components/common/PrivateRoute';
import ManagerLayout from '../components/Products/Manager/ManagerLayout.jsx';
import UsersPage from '../components/Products/Manager/pages/UsersPage.jsx';
import UserFormPage from '../components/Products/Manager/pages/forms/UserFormPage.jsx';
import RestaurantsPage from '../components/Products/Manager/pages/RestaurantsPage.jsx';
import RestauranteFormPage from '../components/Products/Manager/pages/forms/RestauranteFormPage.jsx';
import ClientesPage from '../components/Products/Manager/pages/ClientesPage.jsx';
import ClienteFormPage from '../components/Products/Manager/pages/forms/ClienteFormPage.jsx';
import LogsPage from '../components/Products/Manager/pages/LogsPage.jsx';
import BotsPage from '../components/Products/Manager/pages/BotsPage.jsx';
import AtendabotTemplatePage from '../components/Products/Manager/pages/AtendabotTemplatePage.jsx';
import AtendabotProspectsPage from '../components/Products/Manager/pages/AtendabotProspectsPage.jsx';
import PromotionsPage from '../components/Products/Manager/pages/PromotionsPage.jsx';
import ZapiInstancesPage from '../components/Products/Manager/pages/ZapiInstancesPage.jsx';
import InstagramProfilesPage from '../components/Products/Manager/pages/InstagramProfilesPage.jsx';
import WhatsAppPreviewPromptsPage from '../components/Products/Manager/pages/WhatsAppPreviewPromptsPage.jsx';

const ManagerRoutes = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <PrivateRoute adminOnly>
            <ManagerLayout />
          </PrivateRoute>
        }
      >
        <Route index element={<UsersPage />} />
        <Route path="users" element={<UsersPage />} />
        <Route path="users/new" element={<UserFormPage />} />
        <Route path="users/:id" element={<UserFormPage />} />

        <Route path="restaurantes" element={<RestaurantsPage />} />
        <Route path="restaurantes/new" element={<RestauranteFormPage />} />
        <Route path="restaurantes/:id" element={<RestauranteFormPage />} />

        <Route path="clientes" element={<ClientesPage />} />
        <Route path="clientes/new" element={<ClienteFormPage />} />
        <Route path="clientes/:id" element={<ClienteFormPage />} />

        <Route path="logs" element={<LogsPage />} />
        <Route path="bots" element={<BotsPage />} />
        <Route path="atendabot-template" element={<AtendabotTemplatePage />} />
        <Route path="atendabot-prospects" element={<AtendabotProspectsPage />} />
        <Route path="promotions" element={<PromotionsPage />} />
        <Route path="zapi" element={<ZapiInstancesPage />} />
        <Route path="instagram" element={<InstagramProfilesPage />} />
        <Route path="whatsapp-preview-prompts" element={<WhatsAppPreviewPromptsPage />} />
      </Route>
    </Routes>
  );
};

export default ManagerRoutes;
